import AppConfig from "../appConfig";

const setWithExpiry = (key, value, ttl) =>{
    const now = new Date()
    const item = {
        value: value,
        expiry: now.getTime() + ttl
    }
    localStorage.setItem(key, JSON.stringify(item))
}
const getWithExpiry = (key) => {
    const itemStr = localStorage.getItem(key)
    if (!itemStr) {
        return null
    }

    const item = JSON.parse(itemStr)
    const now = new Date()
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key)
        return null
    }
    return item.value
}
const login = (username, password) => {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password })
    };

    return fetch(`${AppConfig.baseUrl()}/authentication/login`, requestOptions)
        .then(handleResponse)
        .then(userToken => {
            const {
                accessToken,
                //tokenType,
                expiresIn,//seconds
                //refreshToken,
                //authdata
            } = userToken;
            if (accessToken) {
                setWithExpiry("user", {
                    ...userToken,
                    username
                }, expiresIn * 1000);
                return userToken;
            }
            return null;
        });
}

const logout = () => {
    localStorage.removeItem("user");
}

const handleResponse = (response) => {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                logout();
                window.location.reload();
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
const isAuthenticated = () => {
    const user = getWithExpiry("user");
    return !!user;
}
const getLoginUserInfo = () => {
    const user = getWithExpiry("user");
    return user;
}
export const userService = {
    login,
    logout,
    isAuthenticated,
    getLoginUserInfo
};